(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/numbergames-related/assets/pages/related-page.js') >= 0) return;  svs.modules.push('/modules/numbergames-related/assets/pages/related-page.js');

'use strict';

const {
  PayConfirmation
} = svs.numbergames_related.components;
const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
const {
  branding
} = svs.numbergames_related.data;
const RelatedPage = () => React.createElement("div", {
  className: "".concat(branding, "-related")
}, React.createElement(PayConfirmation, null), React.createElement(WidgetArea, {
  areaName: "relatedWidgetArea",
  widgetArea: "relatedWidgetArea"
}));
setGlobal('svs.numbergames_related.pages', {
  RelatedPage
});

 })(window);